import { Component, EventEmitter, Input, OnInit, Output, ViewChild, NgZone } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { IonInput, ModalController, ToastController } from '@ionic/angular';
import { Address } from 'src/app/models/address';
import { AddressService } from 'src/app/services/address.service';
import { ApiProviderService } from 'src/app/services/api-provider.service';
import { UserService } from 'src/app/services/user.service';
import { GoogleMapsAutocompleteService } from 'src/app/services/google-maps-autocomplete.service';

@Component({
  selector: 'app-from-address',
  templateUrl: './from-address.component.html',
  styleUrls: ['./from-address.component.scss'],
})
export class FromAddressComponent implements OnInit {

  suggestedAddresses: any[] = [];
  addressForm: FormGroup;
  @Input() address: Address;
  @Input() returnMode: boolean = false;
  @Output() addressEvent = new EventEmitter<Address>();
  @ViewChild('autocomplete', { static: false }) autoComplete: IonInput;

  constructor(
    private modalCtrl: ModalController,
    private api: ApiProviderService,
    private userService: UserService,
    private toastController: ToastController,
    private addressService: AddressService,
    private autocompleteService: GoogleMapsAutocompleteService,
    private ngZone: NgZone
  ) {}

  ngOnInit() {
    this.initForm();
    this.addressService.loadAddresses();
  }

  ngOnDestroy() {}

  initForm() {
    if (this.address) {
      this.addressForm = new FormGroup({
        Name: new FormControl(this.address.name),
        StreetNumber: new FormControl(this.address.streetNumber),
        Addresse: new FormControl(this.address.addresse),
        CodePostal: new FormControl(this.address.codePostal),
        City: new FormControl(this.address.city)
      });
    } else {
      this.addressForm = new FormGroup({
        Name: new FormControl(''),
        StreetNumber: new FormControl(''),
        Addresse: new FormControl(''),
        CodePostal: new FormControl(''),
        City: new FormControl('')
      });
    }
  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  validate() {
    if (this.addressForm.invalid) {
      return;
    }

    const address = {
      ...this.addressForm.value,
      CoachId: this.userService.getUser().id,
      id: this.address?.id
    };

    if (this.address?.id) {
      this.updateAddress(address);
    } else {
      this.createAddress(address);
    }
  }

  updateAddress(address: Address) {
    this.addressService.editAddress(address).subscribe(
      (data) => {
        this.addressEvent.emit(data);
        return this.modalCtrl.dismiss(data, 'edit');
      },
      async (err) => {
        const toast = await this.toastController.create({
          message: "Erreur lors de l'édition",
          duration: 5000,
          buttons: [
            {
              text: 'Compris',
              role: 'cancel'
            }
          ]
        });
        await toast.present();
      }
    );
  }

  createAddress(address: Address) {
    this.addressService.createAddress(address).subscribe(
      (data) => {
        this.addressEvent.emit(data);
        return this.modalCtrl.dismiss(data, 'create');
      },
      async (err) => {
        const toast = await this.toastController.create({
          message: 'Erreur lors de la création',
          duration: 5000,
          buttons: [
            {
              text: 'Compris',
              role: 'cancel'
            }
          ]
        });
        await toast.present();
      }
    );
  }

  addressChange(event: any) {
    const inputValue = event.target.value; // ici tu récupères la valeur directement
    if (inputValue && inputValue.length > 8) {
      this.autocompleteService.getPlacePredictions(inputValue).subscribe(
        (suggestions) => {
          this.ngZone.run(() => {
            this.suggestedAddresses = suggestions;
          });
        },
        (err) => {
          console.error('Error getting place predictions:', err);
          this.suggestedAddresses = [];
        }
      );
    } else {
      this.suggestedAddresses = [];
    }
  }


  selectAddress(address: any) {
    this.autocompleteService.getParsedAddress(address.placeId).subscribe(
      (parsedAddress) => {
        this.ngZone.run(() => {
          this.addressForm.patchValue({
            StreetNumber: parsedAddress.streetNumber,
            Addresse: parsedAddress.streetName,
            City: parsedAddress.city,
            CodePostal: parsedAddress.postalCode,
            Country: parsedAddress.country
          });
          this.suggestedAddresses = []; // Clear the suggestions
        });
      },
      (err) => {
        console.error('Error getting parsed address:', err);
      }
    );
  }
}
